@if (icon) {
  <app-svg [src]="icon"></app-svg>
}
<div>
  <ng-content></ng-content>
</div>
